(function () {
  function initPricePerLabel() {
    const dataEl = document.querySelector('[data-price-per-label-json]');
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent || '{}').variants || [];
    } catch (e) {
      console.error('PricePerLabel JSON parse failed', e);
      return;
    }

    function getOrCreateHook() {
      let hook = document.querySelector('[data-price-per-label-hook]');
      if (!hook) {
        hook = document.createElement('div');
        hook.className = 'price-per-label-hook';
        hook.setAttribute('data-price-per-label-hook', '');

        const text = document.createElement('span');
        text.className = 'price-per-label-text';
        text.setAttribute('data-price-per-label-text', '');

        hook.appendChild(text);
      }
      return hook;
    }

    function findPluginQuantityTitle() {
      const nodes = document.querySelectorAll('.rio-product-option-title');
      for (const el of nodes) {
        const txt = (el.textContent || '').toLowerCase();
        if (txt.includes('quantity')) return el;
      }
      return null;
    }

    function getSelectedOptionsFromPlugin() {
      const result = {};

      document.querySelectorAll('.rio-product-option-title').forEach((el) => {
        const fullText = (el.textContent || '').toLowerCase();
        const valueEl = el.querySelector('.rio-product-option-title-option-value');
        const selectedValue = valueEl ? (valueEl.textContent || '').trim() : '';
        if (!selectedValue) return;

        if (fullText.includes('color')) result.color = selectedValue;
        if (fullText.includes('quantity')) result.quantity = selectedValue;
      });

      return result;
    }

    function findNativeQuantityTitle() {
      return document.querySelector('.variant-picker [data-option-slug="quantity"] .form__label');
    }

    function getSelectedOptionsFromNative() {
      const result = {};

      const colorEl = document.querySelector('.variant-picker [data-option-slug="color"] .form__label .font-medium');
      const quantityEl = document.querySelector('.variant-picker [data-option-slug="quantity"] .form__label .font-medium');

      if (colorEl) result.color = colorEl.textContent.trim();
      if (quantityEl) result.quantity = quantityEl.textContent.trim();

      return result;
    }

    function findMatchingVariant(selected) {
      if (!selected || Object.keys(selected).length === 0) return null;

      return variants.find((variant) => {
        const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);

        const colorOk = !selected.color || options.includes(selected.color);
        const quantityOk = !selected.quantity || options.includes(selected.quantity);

        return colorOk && quantityOk;
      }) || null;
    }

    function updatePricePerLabel() {
      const hook = getOrCreateHook();
      const textEl = hook.querySelector('[data-price-per-label-text]');
      if (!textEl) return;

      let targetTitle = null;
      let selected = {};
      let variant = null;

      const pluginQuantityTitle = findPluginQuantityTitle();
      if (pluginQuantityTitle) {
        targetTitle = pluginQuantityTitle;
        selected = getSelectedOptionsFromPlugin();
        variant = findMatchingVariant(selected);
      }

      if (!variant) {
        const nativeQuantityTitle = findNativeQuantityTitle();
        if (nativeQuantityTitle) {
          targetTitle = nativeQuantityTitle;
          selected = getSelectedOptionsFromNative();
          variant = findMatchingVariant(selected);
        }
      }

      if (!variant || !targetTitle) {
        hook.hidden = true;
        return;
      }

      const price = Number(variant.price || 0);
      const sheetCount = Number(variant.sheet_count || 0);

      if (!price || !sheetCount) {
        hook.hidden = true;
        return;
      }

      const raw = price / sheetCount / 100;
      const perLabel = Math.floor(raw * 100) / 100;
      const perLabelText = perLabel.toFixed(2);

      textEl.textContent = `(Only $${perLabelText} per label)`;

      targetTitle.insertAdjacentElement('afterend', hook);
      hook.hidden = false;
    }

    updatePricePerLabel();

    document.addEventListener('change', function () {
      setTimeout(updatePricePerLabel, 150);
      setTimeout(updatePricePerLabel, 400);
    }, true);

    document.addEventListener('click', function () {
      setTimeout(updatePricePerLabel, 150);
      setTimeout(updatePricePerLabel, 400);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPricePerLabel);
  } else {
    initPricePerLabel();
  }
})();